<div class="flex flex-col flex-auto min-w-0">
    <!-- Header -->
    <!-- Main -->
    <div class="border-t -mt-px py-2">
        <div class="w-full max-w-screen-xl mx-auto">
            <div class="py-2">
                <div
                    class="grid grid-cols-1 sm:grid-cols-5 gap-6 w-full min-w-0 p-5"
                >
                    <div
                        class="sm:col-span-5 lg:col-span-5 bg-card shadow rounded-2xl overflow-hidden"
                    >
                        <div class="card-header px-6 py-3 border-b">
                            <div
                                class="text-lg font-medium tracking-tight leading-6"
                            >
                                MOC Status Overview
                            </div>
                        </div>

                        <div class="p-6">
                            <div
                                class="grid grid-cols-1 sm:grid-cols-5 gap-6 w-full min-w-0"
                            >
                                <!-- Chart Panel -->
                                <div
                                    class="sm:col-span-3 lg:col-span-3 border rounded-2xl flex items-center justify-center p-6"
                                >
                                    <div
                                        id="mocStatusChart"
                                        class="w-full h-80"
                                    ></div>
                                </div>

                                <!-- Stats Column -->
                                <div
                                    class="sm:col-span-2 lg:col-span-2 flex flex-col gap-4"
                                >
                                    <!-- Permanent and Temporary Summary -->
                                    <div
                                        class="border rounded-2xl overflow-hidden"
                                    >
                                        <div
                                            class="card-header px-4 py-2 border-b"
                                        >
                                            <div
                                                class="text-sm font-semibold tracking-tight leading-6 text-white"
                                            >
                                                Issue Type Summary
                                            </div>
                                        </div>

                                        <div
                                            class="grid grid-cols-1 sm:grid-cols-2 divide-y sm:divide-y-0 sm:divide-x"
                                        >
                                            <div
                                                class="px-4 py-3 flex flex-col items-center justify-center"
                                            >
                                                <span
                                                    class="text-xs font-medium tracking-wide text-gray-500 uppercase"
                                                    >Permanent</span
                                                >
                                                <span
                                                    class="text-2xl font-bold tracking-tight text-gray-900"
                                                    >{{
                                                    mocStatus?.permanentIssue ??
                                                    '0' }}</span
                                                >
                                            </div>

                                            <div
                                                class="px-4 py-3 flex flex-col items-center justify-center"
                                            >
                                                <span
                                                    class="text-xs font-medium tracking-wide text-gray-500 uppercase"
                                                    >Temporary</span
                                                >
                                                <span
                                                    class="text-2xl font-bold tracking-tight text-gray-900"
                                                    >{{
                                                    mocStatus?.temporaryIssue ??
                                                    '0' }}</span
                                                >
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Key Issue Categories -->
                                    <ng-container
                                        *ngIf="keyIssueCategoriesView.length; else noCategoryCard"
                                    >
                                        <div
                                            class="border rounded-2xl overflow-hidden"
                                        >
                                            <div
                                                class="card-header px-4 py-2 border-b"
                                            >
                                                <div
                                                    class="text-sm font-semibold tracking-tight leading-6 text-white"
                                                >
                                                    Key Issue Categories
                                                </div>
                                            </div>

                                            <div class="max-h-80 overflow-auto">
                                                <div
                                                    class="px-4 py-2 border-b last:border-b-0 flex items-center justify-between gap-3"
                                                    *ngFor="let item of keyIssueCategoriesView; trackBy: trackByCategory"
                                                >
                                                    <span
                                                        class="text-sm text-gray-700 truncate"
                                                        [title]="item.category"
                                                        >{{ item.category
                                                        }}</span
                                                    >
                                                    <span
                                                        class="text-sm font-semibold text-gray-900"
                                                        >{{ item.count ?? '0'
                                                        }}</span
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>

                                    <ng-template #noCategoryCard>
                                        <div
                                            class="border rounded-2xl overflow-hidden"
                                        >
                                            <div
                                                class="card-header px-4 py-2 border-b"
                                            >
                                                <div
                                                    class="text-sm font-semibold tracking-tight leading-6 text-white"
                                                >
                                                    Key Issue Categories
                                                </div>
                                            </div>
                                            <div
                                                class="px-4 py-6 flex items-center justify-center"
                                            >
                                                <span
                                                    class="text-base font-medium tracking-tight text-gray-500 text-center"
                                                    >No key issue
                                                    categories</span
                                                >
                                            </div>
                                        </div>
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        class="sm:col-span-5 lg:col-span-5 bg-card shadow rounded-2xl overflow-hidden p-6"
                    >
                        <div
                            role="tablist"
                            class="tabs tabs-boxed w-2/4 mt-2 mb-12"
                        >
                            <a
                                role="tab"
                                class="tab"
                                [ngClass]="{'primary-tab-active': router.url.includes('field')}"
                                (click)="toggleSummary('field')"
                            >
                                Field Summary
                            </a>
                            <a
                                role="tab"
                                class="tab"
                                [ngClass]="{'primary-tab-active': !router.url.includes('field')}"
                                (click)="toggleSummary('string')"
                            >
                                String Summary
                            </a>
                        </div>

                        <router-outlet></router-outlet>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
